import api from '@api'
import { isLoggedIn } from '@utils/auth'
import { transformSupportPortalConfig } from '@data/it-infrastructure'

export function getSupportPortalConfigApi(params) {
  return api
    .get(`${isLoggedIn() ? '/' : '/public/'}supportPortalConfig`, { params })
    .then(transformSupportPortalConfig)
}
